import store from '@/store';
import { log } from '@/utils/common';
import { CONTEXT_TYPE } from '@/utils/constants';

const DEFAULT_PATH = 'composition';
const NORMAL_CONTEXT_PATHS = [
  DEFAULT_PATH,
  'step1',
  'step2',
  'step3',
];

function getType(path) {
  const pathes = path.split('/');
  const idx = pathes.findIndex((n) => n === DEFAULT_PATH);
  const type = pathes[idx + 1];
  if (!type) {
    return DEFAULT_PATH;
  }
  return type;
}

function checkContext(to, ctx, next) {
  if (!to.meta.requiredContext) {
    next();
    return;
  }
  if (to.meta.requiredContext.some((n) => n === ctx.name) && ctx.bundle) {
    next();
  } else {
    next('/');
  }
}

function checkExceptionalContext(to, ctx, next) {
  if (ctx.name === CONTEXT_TYPE.RECOMPOSITION_WITH_REQNO) {
    next();
  } else {
    next('/');
  }
}

export default (to, from, next) => {
  const ctx = store.getters['context/context'];

  if (store.getters['agreement/canProceed']) {
    log('term-guard::', 'user accepted terms.');

    const type = getType(to.path);
    if (NORMAL_CONTEXT_PATHS.includes(type)) {
      if (type === DEFAULT_PATH) {
        next();
      } else {
        checkContext(to, ctx, next);
      }
    } else {
      checkContext(to, ctx, next);
    }
  } else {
    log('term-guard::', 'user not accepted terms or not filled up required value.');
    checkExceptionalContext(to, ctx, next);
  }
};



// WEBPACK FOOTER //
// ./src/router/term-guard.js